export class DynamicFormTemplateBo {
    orderColumn: string = "name";
    currentpageno: number = 1;
    pageitem: number = 10;
    orderType: string = "asc";
    type: string = "string";
    field: string = "name";
    operator: string = "contains";
    value: string = "";
    entityTypeCode: string;
    matchCase: boolean = false;
    agencyId: number | null;
    groupNameLid:any | null;
    statusLid:string='00000000-0000-0000-0000-000000000000';
}


export class saveTemplateBo {
    id:string='00000000-0000-0000-0000-000000000000'
    entityTypeCode: string = "";
    statusLid: string="";
    documentName: string = "";
    name: string = "";
    documentType: string = "";
    template: any;
    agencyId: number | null;
    group:number;
    groupNameLid:any | null;

}
export class DynamicFormTemplateConfigurationBO {
    entityTypeCode: string;
    dynamicFormTemplateId: string;
    name: string;
    statusLid:string;
    formFields: DynamicFormFieldBO[];
}
export class DynamicFormFieldBO {
    id: string;
    formFieldName: string;
    dynamicFormDataDictionaryId: string | null;
    defaultValue: string;
    statusLid:string;
}

export class functionpermission {
    dynamicformtemplatedelete: boolean = true;

}

